<div class="admin-page-wrap">
  <h1 class="page-title"><i class="bi bi-newspaper me-2"></i> News</h1>
  <p class="page-subtitle">Create and manage news items shown on the dashboard. Set headline, body, and active status.</p>

  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-end mb-3">
        <button type="button" class="btn btn-primary" (click)="openCreate()">Create News</button>
      </div>
      @if (error) {
        <div class="alert alert-danger">{{ error }}</div>
      }
      @if (message) {
        <div class="alert alert-success">{{ message }}</div>
      }
      @if (loading) {
        <p class="text-muted">Loading…</p>
      } @else {
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
              <tr>
                <th (click)="setSort('headline')" class="sortable"><span class="me-1">Headline</span><i [class]="'bi ' + sortIcon('headline')"></i></th>
                <th (click)="setSort('active')" class="sortable"><span class="me-1">Active</span><i [class]="'bi ' + sortIcon('active')"></i></th>
                <th (click)="setSort('createdAt')" class="sortable"><span class="me-1">Created</span><i [class]="'bi ' + sortIcon('createdAt')"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (n of sortedContent; track n.id) {
                <tr class="clickable-row" (click)="openEdit(n)" role="button" tabindex="0">
                  <td>{{ n.headline }}</td>
                  <td>{{ n.active ? 'Yes' : 'No' }}</td>
                  <td>{{ n.createdAt }}</td>
                  <td (click)="$event.stopPropagation()">
                    <button type="button" class="btn btn-sm btn-outline-danger" (click)="openDeleteConfirm(n)">Delete</button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        @if (sortedContent.length === 0) {
          <p class="text-muted mb-0">No news items.</p>
        }
      }
    </div>
  </div>
</div>

@if (detailItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ detailItem.id == null ? 'Create news' : 'Edit news' }}</h5>
          <button type="button" class="btn-close" (click)="closeDetail()"></button>
        </div>
        <div class="modal-body">
          <div class="mb-2">
            <label class="form-label">Headline <span class="text-danger">*</span></label>
            <input type="text" class="form-control" [(ngModel)]="detailForm.headline" placeholder="Headline">
          </div>
          <div class="mb-2">
            <label class="form-label">Text</label>
            @if (newsTextEditor) {
              <ngx-editor-menu [editor]="newsTextEditor"></ngx-editor-menu>
              <ngx-editor [editor]="newsTextEditor" [(ngModel)]="detailForm.text" outputFormat="html" placeholder="News text (HTML supported)…"></ngx-editor>
            }
          </div>
          <div class="form-check mb-2">
            <input type="checkbox" class="form-check-input" id="detailActive" [(ngModel)]="detailForm.active">
            <label class="form-check-label" for="detailActive">Active</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDetail()">Cancel</button>
          <button type="button" class="btn btn-primary" [disabled]="detailSaving" (click)="save()">Save</button>
        </div>
      </div>
    </div>
  </div>
}

@if (deleteItem) {
  <div class="modal show d-block" tabindex="-1" style="background: rgba(0,0,0,0.5);">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete news</h5>
          <button type="button" class="btn-close" (click)="closeDeleteConfirm()"></button>
        </div>
        <div class="modal-body">
          @if (deleteError) {
            <div class="alert alert-danger">{{ deleteError }}</div>
          }
          <p>Delete news item <strong>{{ deleteItem.headline }}</strong>? This cannot be undone.</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeDeleteConfirm()">Cancel</button>
          <button type="button" class="btn btn-danger" (click)="confirmDelete()">Delete</button>
        </div>
      </div>
    </div>
  </div>
}
